// Bestanden in de opslagbucket "documents" (administratie, documenten) zijn niet bedoeld voor iedereen
// met de link. De database bewaart de publieke URL van de upload; bij het tonen maken we daar een
// tijdelijke ondertekende link van. Dat werkt al zolang de bucket nog publiek is, en blijft werken
// zodra hij privé staat (alleen ingelogde teamleden mogen ondertekenen).
import { useEffect, useState } from "react";
import { supabase } from "../supabase";

const PUBLIEK = "/storage/v1/object/public/documents/";
const GELDIG_SECONDEN = 3600;

/** Het pad binnen de bucket "documents", of null als de URL daar niet naartoe wijst. */
export function documentPad(url) {
  const i = String(url || "").indexOf(PUBLIEK);
  if (i < 0) return null;
  return decodeURIComponent(String(url).slice(i + PUBLIEK.length).split(/[?#]/)[0]);
}

/** Ondertekende link voor een document-URL; andere URL's komen ongewijzigd terug. */
export async function ondertekendeUrl(url) {
  const pad = documentPad(url);
  if (!pad) return url;
  const { data, error } = await supabase.storage.from("documents").createSignedUrl(pad, GELDIG_SECONDEN);
  return error || !data || !data.signedUrl ? url : data.signedUrl;
}

/** Zelfde als ondertekendeUrl, als hook. Geeft null zolang de link nog wordt aangemaakt. */
export function useOndertekendeUrl(url) {
  const [uit, setUit] = useState(() => (documentPad(url) ? null : url));
  useEffect(() => {
    let weg = false;
    if (!documentPad(url)) { setUit(url); return undefined; }
    setUit(null);
    ondertekendeUrl(url).then((u) => { if (!weg) setUit(u); });
    return () => { weg = true; };
  }, [url]);
  return uit;
}
